export default __webpack_public_path__ + "static/free-speech-c139b080325b26a44c5cb5bb0c4d77b8.png";